import { Component, OnInit } from '@angular/core';
import {  FormBuilder, FormControl, Validators } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { GrievanceTypeService } from '../../grievance-type/grievance-type.service';
import { EscalationDurationService } from '../escalation-duration.service';
import { Board, Departments } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { CommonFunction } from 'src/app/grievance/common-function';


@Component({
  selector: 'app-add-escalation-duration',
  templateUrl: './add-escalation-duration.component.html',
  styleUrls: ['./add-escalation-duration.component.scss'],
})
export class AddEscalationDurationComponent implements OnInit {
  showMsg: boolean = false
  levels: any = [];
  excellationdays: any = []
  Excellationdays: any = []
  isSubmitDisabled: boolean = false;
  progressSpinnerDialog: any = null;

  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);
  protected _onDestroy = new Subject<void>();

  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);
  // phone = new FormControl();

  firstFormGroup = this._formBuilder.group({
    grievanceTypeCtrl: [{ value: null, disabled: true }],
    departmentCtrl: [{ value: null, disabled: true }],
    boardCtrl: [{ value: null, disabled: true }],
    levelCtrl: [{ value: null, disabled: true }],
    selectlevelCtrl: ['', [Validators.required]],
    escalationCtrl: ['', [Validators.required]],
  })
  id: any;
  myid: any;
  depId: any;
  bdid: any;
  gtId: any;

  constructor(
    public _formBuilder: FormBuilder,
    public router: Router,
    public dialog: MatDialog,
    public commonFunction:CommonFunction,
    public escalationService: EscalationDurationService,
    public activatedRoute: ActivatedRoute,
    public grievanceTypeService: GrievanceTypeService,
  ) {}

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');
    this.levels =this.commonFunction.getLevels()
    this.Excellationdays = this.commonFunction.getEscalationDays()
    this.loadPredata()
  }


  async addInput(box) {
    const response: any = await this.escalationService.getAllGrievanceEscalation(this.id)
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          for (var i = 0; i < response.length; i++) {
            this.excellationdays.push(response[i].esLevel)
          }
          this.levels = []
          for (var i = 1; i <= box; i++) {
            this.levels.push(i)
          }
          for (var j = 0; j < this.excellationdays.length; j++) {
            var a = this.levels.indexOf(this.excellationdays[j])
            this.levels.splice(a, 1)
          }
          if (this.levels.length <= 0) {
            this.showMsg = true
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
      } else {
        this.levels = []
        for (var i = 1; i <= box; i++) {
          this.levels.push(i)
        }
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
    }
  }

 


  async submitForm() {
    if (this.firstFormGroup.valid) {
      const data = {
        'fkDepid': this.depId,
        'fkBdid': this.bdid,
        'fkGtId': this.gtId,
        'esLevel': this.firstFormGroup.controls['selectlevelCtrl'].value,
        'esDays': this.firstFormGroup.controls['escalationCtrl'].value,
      }
      this.displayProgressSpinner();
      const response: any = await this.escalationService.submitEscalationDuration(data);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        if (response.status ==ProjectConstants.responseStatusSuccess) {
          // this.successToast();
          await this.commonFunction.successToast(ProjectConstants.esacalationAddSuccessMsg,false,"")
          this.escalationDurationList()
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    }
  }

  async loadPredata() {
    this.displayProgressSpinner();
    const response: any = await this.grievanceTypeService.viewSignleGrievanceType(this.id);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        this.addInput(response.gtLevels);
        this.depId = response.fkDepid;
        this.bdid = response.fkBdid;
        this.gtId = response.pkGtid
        this.firstFormGroup.setValue({
          grievanceTypeCtrl: response.gtGrievanceType,
          departmentCtrl: response.departmentName,
          boardCtrl: response.boardName,
          levelCtrl: response.gtLevels,
          selectlevelCtrl: '',
          escalationCtrl: ''
        })
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
    }
  }


  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }


  // async errorToast() {
  //   await this._snackBar.open(ProjectConstants.networkErMsg, "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "error-toast",
  //     duration: 3 * 1000,
  //   }
  //   );
  // }

  // async successToast() {
  //   await this._snackBar.open(
  //     "Escalation Duration successfully added !!!",
  //     "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "success-toast",
  //     duration: 3 * 1000,
  //   }
  //   );
  // }

  escalationDurationList() {
    this.router.navigate(['secure/list-escalation-duration/' + this.gtId])
  }

}
